import React from 'react';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import {SupplementChip} from 'client/components/QuestionTypes/shared/DraggableChip';
import {extractSupplementParts} from './utils';

interface MarkdownWithSupplementProps {
  text: string;
  className?: string;
  isOptionEliminated?: boolean;
}

/**
 * Renders markdown text with supplement badge support.
 * If the text contains a supplement token, renders the plain text portion
 * via MarkdownRendererV2 alongside a small SupplementChip.
 * Otherwise, renders the full text as standard markdown.
 */
export function MarkdownWithSupplement({
  text,
  className,
  isOptionEliminated
}: MarkdownWithSupplementProps) {
  const parts = extractSupplementParts(text);

  if (!parts) {
    return <MarkdownRendererV2 text={text} className={className} />;
  }

  return (
    <div className={className}>
      {parts.text && <MarkdownRendererV2 text={parts.text} />}
      <SupplementChip
        value={parts.supplementToken}
        size='small'
        isOptionEliminated={isOptionEliminated}
      />
    </div>
  );
}
